import { takeEvery, fork, put, all, call } from "redux-saga/effects"
export function* watchProfile() {
}

function* ProfileSaga() {
  yield all([fork(watchProfile)])
}

export default ProfileSaga
